<template>
  <div>
    <Qualifications :actionItems="actionItems" :profile="profile" />
  </div>
</template>

<script>
// Components
import Qualifications from '@/components/candidate/profile/edit/qualifications/Qualifications'

// Helpers
import { mapGetters } from 'vuex'

export default {
  components: { Qualifications },

  created() {
    Promise.all([this.$store.dispatch('candidate/actionItems/fetchAll')])
      .then(() => {})
      .catch(() => {})
      .finally(() => (this.ready = true))
  },

  props: { profile: { type: Object, required: true } },

  computed: mapGetters({
    actionItems: 'candidate/actionItems/all',
  }),
}
</script>
